module.exports = __webpack_public_path__ + "static/media/YM01_0.cf00924f.jpg";